import { useStore } from '@nanostores/react';

import { $copilotActiveTab } from '@/shared/stores/ui';
import { $effectiveCopilotComposerMode } from '@/shared/stores/ui';

export function useCopilotPanelUiState() {
  const activeTab = useStore($copilotActiveTab);
  const effectiveComposerMode = useStore($effectiveCopilotComposerMode);

  return { activeTab, effectiveComposerMode };
}
